import cookies from './cookies';
import uuidv4 from 'uuid/v4';

const getSessionLong = sessionLong => {
    if (typeof sessionLong !== 'undefined') {
        return sessionLong.slice(0, sessionLong.indexOf('-'));
    }

    const cookieFromServer = cookies.readCookie('onap');

    return (cookieFromServer)
        ? cookieFromServer.slice(0, cookieFromServer.indexOf('-'))
        : undefined;
};

const generateSessionId = () => {
    return `${Date.now()}-${uuidv4()}`;
};

const calculateMaxAgeBeforeMidNight = maxAge => {
    const now = new Date();

    const midnight = new Date(now);

    // eslint-disable-next-line no-magic-numbers
    midnight.setHours(24, 0, 0, 0);
    const timeUntilMidnight = midnight - now;

    return Math.min(maxAge, timeUntilMidnight);
};

export { getSessionLong, generateSessionId, calculateMaxAgeBeforeMidNight };
